import { Box, Button } from '@mui/material';
import styled from 'styled-components';
import pallet from '../../../layouts/pallet';

export const StyledButton = styled(Button).attrs({
  variant: 'contained'
})({
  backgroundColor: `${pallet.red2} !important`,
  color: pallet.white,
  borderRadius: '4px !important',
  height: '30px !important',
  width: '115px !important'
});

export const RefreshButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({});

export const HeaderWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between'
});
